import React from "react";

// Hooks
import { useStore } from "~/hooks/useStore";
// Styles
import s from "~/components/common/Preloader/Preloader.module.scss";
// Types
import RootStore from "~/store/RootStore";
import { observer } from "mobx-react-lite";

import { Spinner } from "@medical/onlinezdrav-ui";

interface Props {}

const Preloader: React.FC<Props> = observer(({}) => {
  const store: RootStore = useStore();
  const isVisible = store.systemStore.loading;

  return (
    <div className={`${s.loader} ${isVisible ? s.loaderVisible : ""}`}>
      <Spinner />
    </div>
  );
});

export default Preloader;
